module.exports = __webpack_public_path__ + "static/media/mentos-sticker.330dd8a7.png";